module.exports = __webpack_public_path__ + "img/MG-black-logo_1200x628.b326ef28.png";